import { render, staticRenderFns } from "./MainHome.vue?vue&type=template&id=6e6f6e97&scoped=true&"
import script from "./MainHome.vue?vue&type=script&lang=js&"
export * from "./MainHome.vue?vue&type=script&lang=js&"
import style0 from "./MainHome.vue?vue&type=style&index=0&id=6e6f6e97&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e6f6e97",
  null
  
)

export default component.exports